import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core"

@Component({
    selector: "app-slide-toggle",
    templateUrl: "./slide-toggle.component.html",
    styleUrls: ["./slide-toggle.component.scss"],
    standalone: false,
})
export class SlideToggleComponent implements OnInit {
    @Input() values: any[] = []
    @Input() selectedOption: string = ""
    @Output() optionChangeEmitter: EventEmitter<string> = new EventEmitter<string>()

    customElementStyle: any
    toggleArray: any[] = []

    ngOnInit() {
        this.defineToggleSelectedElement()
        this.setSelectedOptionStyle()
    }

    ngOnChanges() {
        this.defineToggleSelectedElement()
    }

    emit() {
        this.optionChangeEmitter.emit(this.selectedOption)
        this.defineToggleSelectedElement()
        this.setSelectedOptionStyle()
        this.changeOptionsState()
    }

    changeOptionsState() {
        this.values.map((item: any) => {
            item.selected = item.name === this.selectedOption
        })
    }

    defineToggleSelectedElement() {
        if (this.toggleArray === this.values) return
        this.toggleArray = this.values
        const selectedElement = this.toggleArray.find((element) => element.selected === true)
        if (selectedElement) {
            this.selectedOption = selectedElement.name
        } else {
            this.selectedOption = this.toggleArray[0].name
        }
    }

    //TODO: improvements can be added - working good for @this.values.length === 2
    setSelectedOptionStyle() {
        let selectedOptionIndex: number = this.values.findIndex(
            (value) => value.name === this.selectedOption
        )
        if (selectedOptionIndex <= 0) {
            this.customElementStyle = "translate(0%)"
        } else {
            this.customElementStyle =
                "translate(" + (selectedOptionIndex / (this.values.length - 1)) * 100 + "%)"
        }
    }

    //TODO: improvements can be added - working good for @this.values.length === 2
    get mediumWidth() {
        return 100 / this.values.length + "%"
    }
}
